import cx from 'classnames';
import type { ReactNode } from 'react';
import { deprecate } from '../../utils/deprecate';
import styles from './styles.module.css';

export interface HighlightProps {
  dark?: boolean;
  children: NonNullable<ReactNode>;
}

/** @deprecated use Highlight from kitt-universal instead */
export function Highlight({ dark, children }: HighlightProps): ReactNode {
  if (__DEV__) deprecate(Highlight.name, 'Use Highlight from kitt-universal instead');
  return (
    <div
      className={cx(styles.Highlight, {
        [styles.Dark]: dark,
      })}
    >
      {children}
    </div>
  );
}
